import React, { PureComponent } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import styled from 'styled-components';
import plotly from './../node_modules/plotly.js/dist/plotly.js';
import ComponentTitle from './ComponentTitle';
import UpdatedDate from './UpdatedDate';
import { normalizeBarTooltips } from './normalizeBarTooltips';

const StyledFilePlotsComponent = styled.div`
  grid-column: span 12;
`;

const StyledFilePlotComponent = styled.div`
  margin-top: 20px;
`;

const StyledMissingComponent = styled.div`
  position: relative;
  background: white;
  padding-bottom: 35px;
  margin-bottom: 20px;
`;

const StyledFeaturesComponent = styled.div`
  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 40px 10px;
`;

const StyledFeatureComponent = styled.div`
  position: relative;
  background: white;
  padding-bottom: 30px;
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span 3;
  }
`;

class FilePlotsComponent extends PureComponent {
  render() {
    const config = {
      modeBarButtonsToRemove: [
        'toImage',
        'sendDataToCloud',
        'zoomIn2d',
        'zoomOut2d',
        'autoScale2d',
        'toggleSpikelines',
        'lasso2d',
        'select2d'
      ],
      displaylogo: false,
      responsive: true,
      locale: 'de'
    };

    const { title, info } = this.props;

    return (
      <StyledFilePlotsComponent>
        <ComponentTitle title={title} info={info} />
        {this.props.data.map((filePlot, index) => {
          const filePlotData = JSON.parse(filePlot.data);
          if (filePlotData.missing && filePlotData.missing.data && filePlotData.missing.data.data) {
            normalizeBarTooltips(filePlotData.missing.data.data);
          }
          const Plot = createPlotlyComponent(plotly);
          let layout;
          if (filePlotData.missing) {
            layout = Object.assign({}, filePlotData.missing.data.layout);
            layout.font.family = 'latoregular';
            layout.font.color = '#6D7B80';
            layout.autosize = true;
            layout.width = undefined;
            layout.height = undefined;
            layout.line = { dash: 'dot' };
            if (layout.title) {
              if (layout.title.font) {
                layout.title.font.family = 'latoregular';
                layout.title.font.color = '#42515A';
              } else {
                layout.title = {
                  font: {
                    family: 'latoregular',
                    color: '#42515A'
                  }
                };
              }
            }
            if (layout.legend) {
              if (layout.legend.font) {
                layout.legend.font.family = 'latoregular';
                layout.legend.font.color = '#42515A';
              } else {
                layout.legend = {
                  font: {
                    family: 'latoregular',
                    color: '#42515A'
                  }
                };
              }
            }
            layout.annotations &&
              layout.annotations.forEach(annotation => {
                if (!annotation) {
                  return;
                }
                if (!annotation.font) {
                  annotation.font = {
                    family: 'latoblack',
                    color: '#42515A'
                  };
                } else {
                  annotation.font.family = 'latoblack';
                  annotation.font.color = '#42515A';
                }
                annotation.y = annotation.y + 0.01;
              });
            layout.xaxis.color = '#6D7B80';
            layout.xaxis.tickfont.family = 'latoregular';
            layout.xaxis.tickfont.color = '#6D7B80';
            layout.yaxis.color = '#6D7B80';
            layout.yaxis.ticks = '';
            layout.yaxis.tickfont.family = 'latoregular';
            layout.yaxis.tickfont.color = '#6D7B80';
            layout.yaxis.gridcolor = '#f0f2f2';
            layout.yaxis.zeroline = true;
            if (layout.yaxis.ticktext) {
              layout.yaxis.ticktext = layout.yaxis.ticktext.map(
                ticktext => '   ' + ticktext
              );
            }
            layout.yaxis.zerolinecolor = '#6D7B80';
            layout.margin.l = 90;
          }
          return (
            <StyledFilePlotComponent key={index}>
              <ComponentTitle
                title={filePlot.title}
                info={filePlot.info_text}
              />
              {filePlotData.missing && (
                <StyledMissingComponent>
                  <ComponentTitle
                    title={filePlotData.missing.title}
                    info={filePlotData.missing.info_text}
                  />
                  <Plot
                    data={filePlotData.missing.data.data}
                    layout={layout}
                    config={config}
                    useResizeHandler={true}
                    style={{
                      width: '100%',
                      height: `${this.props.heightInPx
                          ? `${this.props.heightInPx}px`
                          : 'auto'
                        }`
                    }}
                  />
                  <UpdatedDate>{`letztes Update: ${this.props.lastUpdated
                    }`}</UpdatedDate>
                </StyledMissingComponent>
              )}

              <StyledFeaturesComponent>
                <ComponentTitle
                  title={filePlotData.features.title}
                  info={filePlotData.features.info_text}
                  columns={12}
                />
                {filePlotData.features.data.map((feature, index) => {
                  const Plot = createPlotlyComponent(plotly);
                  if (feature.data && feature.data.data) {
                    normalizeBarTooltips(feature.data.data);
                  }
                  let layout = Object.assign({}, feature.data.layout);
                  layout.font.family = 'latoregular';
                  layout.font.color = '#6D7B80';
                  layout.autosize = true;
                  layout.width = undefined;
                  layout.height = undefined;
                  layout.line = { dash: 'dot' };
                  if (layout.title) {
                    if (layout.title.font) {
                      layout.title.font.family = 'latoregular';
                      layout.title.font.color = '#42515A';
                    } else {
                      layout.title = {
                        font: {
                          family: 'latoregular',
                          color: '#42515A'
                        }
                      };
                    }
                  }
                  if (layout.legend) {
                    if (layout.legend.font) {
                      layout.legend.font.family = 'latoregular';
                      layout.legend.font.color = '#42515A';
                    } else {
                      layout.legend = {
                        font: {
                          family: 'latoregular',
                          color: '#42515A'
                        }
                      };
                    }
                  }
                  layout.annotations &&
                    layout.annotations.forEach(annotation => {
                      if (!annotation) {
                        return;
                      }
                      if (!annotation.font) {
                        annotation.font = {
                          family: 'latoblack',
                          color: '#42515A'
                        };
                      } else {
                        annotation.font.family = 'latoblack';
                        annotation.font.color = '#42515A';
                      }
                      annotation.y = annotation.y + 0.01;
                    });
                  layout.xaxis.color = '#6D7B80';
                  layout.xaxis.tickfont.family = 'latoregular';
                  layout.xaxis.tickfont.color = '#6D7B80';
                  layout.yaxis.color = '#6D7B80';
                  layout.yaxis.ticks = '';
                  layout.yaxis.tickfont.family = 'latoregular';
                  layout.yaxis.tickfont.color = '#6D7B80';
                  for (let i = 1; i < 11; i++) {
                    if (layout[`xaxis${i}`]) {
                      layout[`xaxis${i}`].color = '#6D7B80';
                      layout[`xaxis${i}`].tickfont.family = 'latoregular';
                      layout[`xaxis${i}`].tickfont.color = '#6D7B80';
                    }
                    if (layout[`yaxis${i}`]) {
                      layout[`yaxis${i}`].color = '#6D7B80';
                      layout[`yaxis${i}`].tickfont.family = 'latoregular';
                      layout[`yaxis${i}`].tickfont.color = '#6D7B80';
                    }
                  }
                  layout.yaxis.gridcolor = '#f0f2f2';
                  layout.yaxis.zeroline = true;
                  if (layout.yaxis.ticktext) {
                    layout.yaxis.ticktext = layout.yaxis.ticktext.map(
                      ticktext => '   ' + ticktext
                    );
                  }
                  layout.yaxis.zerolinecolor = '#6D7B80';
                  layout.margin.l = 90;
                  return (
                    <StyledFeatureComponent key={index}>
                      <ComponentTitle
                        title={feature.title}
                        info={feature.info_text}
                      />
                      <Plot
                        data={feature.data.data}
                        layout={layout}
                        config={config}
                        useResizeHandler={true}
                        style={{ width: '100%', height: '100%' }}
                      />
                      <UpdatedDate>{`letztes Update: ${this.props.lastUpdated
                        }`}</UpdatedDate>
                    </StyledFeatureComponent>
                  );
                })}
              </StyledFeaturesComponent>
            </StyledFilePlotComponent>
          );
        })}
      </StyledFilePlotsComponent>
    );
  }
}

export default FilePlotsComponent;
